export default "__VITE_ASSET__D2E6wgPA__"